//GET
export const getAuctionsSync = (obj) => `${process.env.REACT_APP_END_POINT_BD}/api/${obj.version}/${obj.lang}/public/auction/${obj.aucId}/sync?` + Math.random()
